// extracted by mini-css-extract-plugin
export default {"popover":"styles_popover__YCSiB"};